<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col md="12">
				<b-card>
					<template v-slot:header>
						<b-row>
							<b-col md="6">
								<strong>Tickets Pendientes de Autorización</strong>
							</b-col>
							<b-col md="6" class="d-flex justify-content-end">
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small></b-spinner>
								</div>
							</b-col>
						</b-row>
					</template>
					<b-card-body class="table-responsive">
						<b-table :items="pendingAuthTickets"
								 :fields="ticketTableFields"
								 show-empty
								 :busy="loading"
								 empty-filtered-text="No tiene tickets pendientes de autorización"
								 empty-text="No tiene tickets pendientes de autorización"
								 head-variant="light">
							<template v-slot:table-busy>
								<div class="text-center text-info my-2">
									<b-spinner class="align-middle"></b-spinner>
								</div>
							</template>
							<div slot="Account" slot-scope="item">
								{{item.item.Account.Alias}}
							</div>
							<div slot="CreatedOn" slot-scope="item">
								{{item.item.CreatedOn | dateFormatFull}}
							</div>

							<div slot="Detail" slot-scope="item">
								<b-button class="btn-block btn-sm"
										  v-b-tooltip.hover title="Autorizar Ticket"
										  v-if="!loading"
										  variant="success"
										  @click="authTicket(item.item.Id, item.item.Account.Id)">
									<i class="fa fa-check text-white" aria-hidden="true"></i>
								</b-button>
							</div>

						</b-table>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
	import {mapState} from "vuex";

	export default {
		name: "PendingAuthTicketList",
		data: function () {
			return {
				ticketTableFields: {
					Number: {
						label: 'Número'
					},
					Account: {
						label: 'Cuenta'
					},
					Description: {
						label: 'Descripción'
					},
					Priority: {
						label: 'Prioridad'
					},
					CreatedOn: {
						label: 'Fecha de Creación'
					},
					Detail: {
						label: ''
					}
				},
				loading: false
			}
		},
		methods: {
			getPendingAuthTickets() {
				this.loading = true;
				this.$store.dispatch('getPendingAuthTickets')
					.finally(() => {
						this.loading = false;
					})
			},
			authTicket(ticketId, accountId) {
				this.loading = true;
				this.$store.dispatch('quickAuthTicket', {TicketId: ticketId, AccountId: accountId})
					.then(() => {
						this.getPendingAuthTickets();
					})
					.catch((err) => {
						console.log(err);
					})
					.finally(() => {
						this.loading = false;
					})
			}
		},
		computed: {
			...mapState({
				user: state => JSON.parse(state.user),
				pendingAuthTickets: state => state.pendingAuthTickets,
			})
		}
	}
</script>

<style scoped>

</style>
